module.exports = __webpack_public_path__ + "static/media/icon-service-modulesA3.068269b5.png";